<style scoped>
.fill-height {
  height: calc(100vh - 56px);
  overflow-y: auto;
  overflow-x: hidden;
}
</style>

<template>

<div>
  <Empty 
    :message="$t('prompt.redirect')"
    class="fill-height" />
</div>

</template>

<script>
import Empty from '@/components/Empty.vue'
export default {
  name: "RedirectPage",
  components: {
    Empty
  }
};
</script>
